import React from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import { professionalAction, userActions } from "../../_actions";
import { AppTable } from "../../_components/AppTable";
import config from "../../config";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  Divider,
  PageHeader,
  Descriptions,
  message,
 
} from "antd";
import axios from 'axios';

import { ViewFormModel } from "../ProfessionalForm/ViewForm/ViewFormModel";


const { Option } = Select;
const FormItem = Form.Item;
let columns = [];
let data = [];

const baseUrl = config.apiGateway.baseUrl;

class CriminalView extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    isCreateUserDrawerVisible: false,
    isUpdate:false,
    userFormEditData:[],
    resetFrom:false,
    userList:[],
    progress:0,
    fileList:[],
    uploadedFileName:''
  };
  userForm = React.createRef();


  componentDidMount() {
    const { user } = this.props;
    const criminalId= this.props.match.params.id;
    if (criminalId) {
      this.props.dispatch(professionalAction.getCriminalsViewsByIdView(criminalId));
    }
 }

 

  componentDidUpdate(prevState) {
    
  }

  
  render() {
    const { users } = this.props;
    const { professionals, user } = this.props;
    
    const requiredKeys = [];
   
    return (
      <div className="col-md-6 col-md-offset-3">
         <ViewFormModel dataStates={professionals}></ViewFormModel>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals
  };
}

const connectedCriminalView = connect(mapStateToProps)(CriminalView);
export { connectedCriminalView as CriminalView };
